import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState = {
    formType: '',
    accessType: ''
};

export const ducSlice = createSlice({
    name: 'duc',
    initialState: initialState as any,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setAccessType: (state, action: PayloadAction<string>) => {
            state.formType = action.payload;
        },
        setFormType: (state, action: PayloadAction<string>) => {
            state.formType = action.payload;
        },
    }
});

export const { setFormType } = ducSlice.actions;

export const { setAccessType } = ducSlice.actions;
export default ducSlice.reducer;

export const selectFormType = (state: any) => state.duc.formType;
export const selectAccessType = (state: any) => state.duc.accessType;
